/**
 * Sun Frog site nav drawer (ported from proto load-components.js).
 */
(function () {
  function closeSiteNav(menuBtn, nav) {
    nav.classList.remove("is-open");
    nav.setAttribute("aria-hidden", "true");
    menuBtn.setAttribute("aria-expanded", "false");
    menuBtn.setAttribute("aria-label", "Open menu");
    document.body.classList.remove("nav-open");
  }

  function openSiteNav(menuBtn, nav) {
    nav.classList.add("is-open");
    nav.setAttribute("aria-hidden", "false");
    menuBtn.setAttribute("aria-expanded", "true");
    menuBtn.setAttribute("aria-label", "Close menu");
    document.body.classList.add("nav-open");
  }

  function initSiteNav() {
    const header = document.getElementById("site-header");
    if (!header) return;

    const menuBtn = header.querySelector(".top-bar__menu");
    const nav = header.querySelector("#main-nav");
    const backdrop = header.querySelector(".nav-drawer-backdrop");
    const closeBtn = header.querySelector(".main-nav__close");
    if (!menuBtn || !nav) return;
    if (menuBtn.dataset.navBound === "true") return;
    menuBtn.dataset.navBound = "true";

    menuBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (nav.classList.contains("is-open")) {
        closeSiteNav(menuBtn, nav);
      } else {
        openSiteNav(menuBtn, nav);
      }
    });

    closeBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      closeSiteNav(menuBtn, nav);
    });

    backdrop?.addEventListener("click", () => closeSiteNav(menuBtn, nav));

    nav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => closeSiteNav(menuBtn, nav));
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && nav.classList.contains("is-open")) {
        closeSiteNav(menuBtn, nav);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSiteNav);
  } else {
    initSiteNav();
  }
})();
